import { makeStyles } from "@fluentui/react-components";

export const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
  },
  inventoryGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
    gap: "20px",
    width: "100%",
    maxWidth: "1000px",
    marginTop: "20px",
  },
  box: {
    backgroundColor: "var(--card-hover-light, #0078D4)",
    color: "white",
    padding: "20px",
    borderRadius: "8px",
    textAlign: "center",
    cursor: "pointer",
    transition: "0.3s",
    boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
    border: "1px solid var(--border-color, transparent)",
    "&:hover": {
      boxShadow: "0px 6px 12px rgba(0,0,0,0.3)",
      backgroundColor: "var(--hover-background, #005A9E)",
    },
  },
  selectedBox: {
    backgroundColor: "var(--card-hover-light, #005A9E)",
    boxShadow: "0px 12px 12px rgba(0,0,0,0.5)",
  },
});